import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";
import { Queries } from "ui/query/queries";
import { giftcardsApi } from "../api/giftcardsApi";

export interface UsePreviewVoucherParams {
    allyId: string;
    status: "COMPLETED" | "PENDING";
}

export default function usePreviewVoucher(
    { allyId, status }: UsePreviewVoucherParams,
    options?: UseQueryOptions<string, unknown, string, string[]>,
): UseQueryResult<string> {
    return useQuery(
        [Queries.GIFTCARD_PREVIEW_VOUCHER, allyId, status],
        async () => {
            const res = await giftcardsApi.getPreviewVoucher({ allyId, status });
            return res.data;
        },
        { ...options },
    );
}
